module.exports = __webpack_public_path__ + "static/media/sunny2.a4cd1854.jpeg";